// src/components/Header.js
import React from 'react';

function Footer() {
  return (
    
    <div className="footer1 _relative" style={{backgroundColor:'#e3e4ed'}}>
    <div className="container">
         <div className="row">
              <div className="col-lg-4 col-md-6 col-12">
                   <div className="single-footer-items footer-logo-area">
                        <div className="footer-logo">
                          <a href=""><img src="assets/img/logo/M2V Consulting.png" alt=""/></a>
                        </div>
                        <div className="space20"></div>
                        <div className="heading1 text-center">
                          <p style={{fontWeight:'bolder'}}>Innovate. Integrate. Accelerate.</p>
                        </div>
                        {/* <ul className="social-icon">
                             <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                             <li><a href="#"><i className="fa-brands fa-x-twitter"></i></a></li>
                             <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
                             <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                        </ul> */}
                   </div>
              </div>

              <div className="col-lg col-md-6 col-12">
                   <div className="single-footer-items">
                        <h3>Service We Offer</h3>

                        <ul className="menu-list">
                             <li><a href="/services">Cross-Platform Expertise</a></li>
                             <li><a href="/services">End-to-End Implementation</a></li>
                             <li><a href="/services">Training & Enablement</a></li>
                             <li><a href="/services">Platform Optimization & Enhancements</a></li>
                             <li><a href="/services">ServiceNow Strategy & Advisory</a></li>
                        </ul>
                   </div>
              </div>

              {/* <div className="col-lg col-md-6 col-12">
                   <div className="single-footer-items">
                        <h3>Useful Links</h3>

                        <ul className="menu-list">
                             <li><a href="/about_us">About Us </a></li>
                             <li><a href="/services">Our Services</a></li>
                             <li><a href="#">Blog & News</a></li>
                            
                             <li><a href="/contact_us">Contact Us</a></li>
                        </ul>
                   </div>
              </div> */}


              <div className="col-lg-3 col-md-6 col-12">
                   <div className="single-footer-items">
                        <h3>Contact Us</h3>

                        {/* <div className="contact-box">
                          <div className="icon">
                            <img src="assets/img/icons/footer1-icon1.png" alt=""/>
                          </div>
                          <div className="pera">
                            <a href="tel:+919211047778">+91 9211047778</a>
                          </div>
                        </div> */}

                        <div className="contact-box">
                          <div className="icon">
                            <img src="assets/img/icons/footer1-icon2.png" alt=""/>
                          </div>
                          <div className="pera">
                            <a href="tel:+919211047778">+91 9211047778</a>
                          </div>
                        </div>

                        <div className="contact-box">
                          <div className="icon">
                            <img src="assets/img/icons/footer1-icon3.png" alt=""/>
                          </div>
                          <div className="pera">
                            <a href="mailto:info@m2vconsulting.com">info@m2v-consulting.com</a>
                          </div>
                        </div>

                        <div className="contact-box">
                          <div className="icon">
                            <img src="assets/img/icons/footer1-icon4.png" alt=""/>
                          </div>
                          <div className="pera">
                            <a href="mailto:admin@techxen.org">www.m2v-consulting.com</a>
                          </div>
                        </div>

                   </div>
              </div>

         </div>

         <div className="space40"></div>
    </div>

    <div className="copyright-area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5">
               <div className="coppyright">
                 <p>Copyright @2025 M2V Consulting. All Rights Reserved</p>
               </div>
          </div>
          <div className="col-md-7">
               <div className="coppyright right-area">
                    <a href="#">Terms & Conditions</a>
                    <a href="#">Privacy Policy</a>
               </div>
          </div>
     </div>
      </div>
 </div>

  </div>
  );
}

export default Footer;
